import React from 'react';
import styles from './Style.module.css';

export const OfflineBanner = () => {

  return (
    <div className={`${styles.offlineBanner}`}>
      Offline. Trying to reconnect...
    </div>
  );
};

export default OfflineBanner;
